var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('back-to-top',{attrs:{"bottom":0,"right":10}},[_c('div',{staticClass:"btn-to-top"},[_c('div',{staticClass:"btn-to-top-icon"},[_c('i',{staticClass:"fal fa-long-arrow-up"})]),_c('div',{staticClass:"btn-to-top-text"},[_vm._v(" Top ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }